import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export const syncSourceCalendar = async ({ rangeStart, rangeEnd }) => {
	const callable = httpsCallable(functions, 'syncSourceCalendar');
	const result = await callable({ rangeStart, rangeEnd });
	return result.data;
};

export const generateTeacherSchedule = async ({ rangeStart, rangeEnd, runId }) => {
	const callable = httpsCallable(functions, 'generateTeacherSchedule');
	const payload = runId ? { runId, rangeStart, rangeEnd } : { rangeStart, rangeEnd };
	const result = await callable(payload);
	return result.data;
};

export const releaseScheduleRun = async ({ runId }) => {
	const callable = httpsCallable(functions, 'releaseScheduleRun');
	const result = await callable({ runId });
	return result.data;
};

export const updateScheduleAssignment = async ({ assignmentId, teacherId, isLocked, notes }) => {
	const callable = httpsCallable(functions, 'updateScheduleAssignment');
	const result = await callable({ assignmentId, teacherId, isLocked, notes });
	return result.data;
};

export const bulkUpdateScheduleAssignments = async ({ assignmentIds, teacherId, isLocked }) => {
	const callable = httpsCallable(functions, 'bulkUpdateScheduleAssignments');
	const result = await callable({ assignmentIds, teacherId, isLocked });
	return result.data;
};
